import { Grid, useTheme, styled } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import MxIcons from "@rf-l1/MxIcons";
import { IconTrashFilled } from "@tabler/icons-react";
import { useRoma } from "@rf-l1/roma/RomaContext";
import useAlert from "@rf-hooks/useAlert";

const MxFieldFooterDescription = () => {
  const theme = useTheme();
  const { warningAlert } = useAlert();

  const {
    data = [],
    handleOpenDropzone,
    onDeleteAllFiles,
    accept,
    maxSize
  } = useRoma();

  const handleDeleteAllFiles = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    warningAlert({
      message: "¿Estás seguro de querer eliminar todas las imágenes?",
      confirmBtnMessage: "Eliminar",
      declineBtnMessage: "Cancelar"
    }).then(res => {
      if (res.type.confirm) {
        onDeleteAllFiles();
      }
    });
  };

  return (
    <Content container item xs={12} alignSelf="flex-end">
      <Grid
        container
        item
        xs={"auto"}
        position={"relative"}
        sx={{ zIndex: 0 }}
        gap={2}
      >
        <Grid item xs={"auto"}>
          <MxButton2
            testId="search-images-button"
            variant="outlined"
            borderWidth={1}
            borderColor={theme.palette.primary.main}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenDropzone();
            }}
          >
            Buscar imágenes
          </MxButton2>
        </Grid>

        {data.length > 0 && (
          <Grid item xs={"auto"}>
            <MxButton2
              testId="delete-all-images-button"
              variant="text"
              onClick={handleDeleteAllFiles}
              textColor="error.main"
              fontWeight={600}
              startIcon={
                <MxIcons size={16} color="error.main">
                  <IconTrashFilled stroke={1.5} />
                </MxIcons>
              }
            >
              Borrar todo
            </MxButton2>
          </Grid>
        )}
      </Grid>

      <PlaceHolderContent container item flex={data.length ? 0.8 : 0.9}>
        <Grid item xs={12}>
          <MxTypography variant="overline" color="primary.main" textAlign="center">
            Arrastre las imágenes aquí o seleccione desde los archivos formato{" "}
            {accept.join(", ")}) el tamaño máximo de las imágenes es de {maxSize} MB
          </MxTypography>
        </Grid>

        <Grid item xs={12}>
          <MxTypography
            variant="overline"
            color="gray"
            textAlign="center"
            fontWeight={500}
          >
            Puedes agregar un máximo de 20 imágenes
          </MxTypography>
        </Grid>
      </PlaceHolderContent>
    </Content>
  );
};

export default MxFieldFooterDescription;

const Content = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: 1
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    gap: 2
  }
}));

const PlaceHolderContent = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    gap: 0
  },
  [theme.breakpoints.up("sm")]: {
    gap: 1
  }
}));
